<div class="contains-button">
  <div style="display: flex; align-items: center; gap: 4px; flex-wrap: wrap;">
    <button [ngClass]="configMode == 'basic' ? 'ant-btn ant-btn-primary' : 'ant-btn'" class="d-flex align-items-center" (click)="configMode = 'basic'">
      <span>{{('cau_hinh_co_ban') | translate}}</span>
    </button>
  
    <button [ngClass]="configMode == 'advanced' ? 'ant-btn ant-btn-primary' : 'ant-btn'" class="d-flex align-items-center" (click)="configMode = 'advanced'">
      <span>{{('cau_hinh_nang_cao') | translate}}</span>
    </button>
  </div>
  <!-- Cấu hình cơ bản -->
  <ng-container *ngIf="configMode == 'basic'">
    <div style="margin-top: 10px">
              <!-- chữ nền -->
              <ng-container>
                <div class="config-text" style="width: 100%">
                  <mat-form-field style="width: 100%">
                    <mat-label>{{'chu_nen' | translate}}</mat-label>
                    <textarea matInput
                      [ngModel]="staticdata['input_text_placeholder_' + functionService.selectedLanguageCode] | vhLanguage : 'input_text_placeholder' : objectChoosing.component"
                      (ngModelChange)="staticdata['input_text_placeholder_' + functionService.selectedLanguageCode] = $event"
                      (blur)="updateContent()">
                      </textarea>
                  </mat-form-field>
                </div>
              </ng-container>
      
              <!-- màu chữ nền -->
              <div class="color-pick">
                <span class="title w-50">{{'mau_chu_nen' | translate}}</span>
                <input class="input-color w-50" type="button" [cpOKButton]="true"
                  [(colorPicker)]="class['note-bill__boundary-placeholder']['color']"
                  [style.background]="class['note-bill__boundary-placeholder']['color']" (colorPickerClose)="updateObject()"
                  [cpWidth]="'230px'" />
              </div>
              <!-- cấu hình text -->
              <div class="config-font-size mt-2">
                <div class="field-row-font" style="width: 65%">
                  <mat-form-field title="Font" style="width: 100%">
                    <mat-label> {{'kieu_chu' | translate}}
                    </mat-label>
                    <mat-select [(ngModel)]="
                            class['note-bill__boundary']['font-family']
                          " (ngModelChange)="updateClass()" [(value)]="class['note-bill__boundary']['font-family']">
                      <mat-option *ngFor="let font of fonts" [value]="font.value">{{
                        font.name
                        }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="field-row-size" style="width: 35%">
                  <mat-form-field title="Size" style="width: 100%">
                    <mat-label> {{'kich_thuoc' | translate}}</mat-label>
                    <input matInput type="number" [ngModel]="
                            class['note-bill__boundary']['font-size'] | vhnumber
                          " (ngModelChange)="
                            class['note-bill__boundary']['font-size'] =
                              $event + 'px'
                          " />
                  </mat-form-field>
                </div>
              </div>
              <div class="config-font">
                <p class="title-font" style="margin-bottom: 10px;"> {{'dinh_dang' | translate}}</p>
                <div class="field-row">
                  <button class="font-text-btn font-text-btn-bold" title="Bold" nz-button [nzType]="
                          class['note-bill__boundary']['font-weight'] == 'bold'
                            ? 'primary'
                            : 'default'
                        " (click)="
                          class['note-bill__boundary']['font-weight'] =
                            class['note-bill__boundary']['font-weight'] == 'bold'
                              ? '500'
                              : 'bold';
                          updateClass()
                        ">
                    <span style="font-weight: 600">B</span>
                  </button>
                  <button class="font-text-btn font-text-btn-italic" title="Italic" nz-button [nzType]="
                          class['note-bill__boundary']['font-style'] == 'italic'
                            ? 'primary'
                            : 'default'
                        " (click)="
                          class['note-bill__boundary']['font-style'] =
                            class['note-bill__boundary']['font-style'] == 'normal'
                              ? 'italic'
                              : 'normal';
                          updateClass()
                        ">
                    <i nz-icon nzType="italic" nzTheme="outline" style="font-size: 14px"></i>
                  </button>
                  <button class="font-text-btn font-text-btn-underline" title="Underline" nz-button [nzType]="
                          class['note-bill__boundary']['text-decoration'] ==
                          'underline'
                            ? 'primary'
                            : 'default'
                        " (click)="
                          class['note-bill__boundary']['text-decoration'] =
                            class['note-bill__boundary']['text-decoration'] ==
                            'none'
                              ? 'underline'
                              : 'none';
                          updateClass()
                        ">
                    <i nz-icon nzType="underline" nzTheme="outline" style="font-size: 14px"></i>
                  </button>
                  <button class="font-text-btn font-text-btn-line-through" title="Line-through" nz-button [nzType]="
                          class['note-bill__boundary']['text-decoration'] ==
                          'line-through'
                            ? 'primary'
                            : 'default'
                        " (click)="
                          class['note-bill__boundary']['text-decoration'] =
                            class['note-bill__boundary']['text-decoration'] ==
                            'none'
                              ? 'line-through'
                              : 'none';
                          updateClass()
                        ">
                    <i nz-icon nzType="strikethrough" nzTheme="outline" style="font-size: 14px"></i>
                  </button>
                  <button class="font-text-btn font-text-btn-uppercase" title="Uppercase" nz-button [nzType]="
                          class['note-bill__boundary']['text-transform'] ==
                          'uppercase'
                            ? 'primary'
                            : 'default'
                        " (click)="
                          class['note-bill__boundary']['text-transform'] =
                            class['note-bill__boundary']['text-transform'] ==
                            'none'
                              ? 'uppercase'
                              : 'none';
                          updateClass()
                        ">
                    <span>AB</span>
                  </button>
                  <div>
                    <input id="color2" title="Color" type="button" [cpOKButton]="true"
                      [(colorPicker)]="class['note-bill__boundary']['color']"
                      [style.background]="class['note-bill__boundary']['color']" (colorPickerClose)="updateObject()"
                      [cpWidth]="'230px'" [cpPositionRelativeToArrow]="true" />
                  </div>
                </div>
              </div>
              <!-- màu nền -->
              <div class="color-pick">
                <span class="title w-50">{{'mau_nen' | translate}}</span>
                <input class="input-color w-50" type="button" [cpOKButton]="true"
                  [(colorPicker)]="class['note-bill__boundary']['background-color']"
                  [style.background]="class['note-bill__boundary']['background-color']" (colorPickerClose)="updateObject()"
                  [cpWidth]="'230px'" />
              </div>
    </div>
  </ng-container>

  <div class="editor-header" *ngIf="isViewAll">
    <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
    <span (click)="isViewAll = !isViewAll">{{ currentViewAll.title | translate }}</span>
  </div>
  <ng-container *ngIf="!isViewAll && configMode == 'advanced'">
    <ul style="padding: 0" nz-menu nzMode="inline" [nzInlineCollapsed]="isCollapsed">
      <li nz-submenu nzTitle="{{'hien_thi'| translate}}" [(nzOpen)]="openMap.menu1"
        (nzOpenChange)="openHandler('menu1')">
        <div class="button-size">

          <!-- Lựa chọn hiển thị cho các thiết bị -->
          <app-hide-show-config [device]="device" [elementChoosing]="objectChoosing">
          </app-hide-show-config>
        </div>
      </li>
      <!-- Cấu hình tái sử dụng thiết kế-->

      <!-- Thông số cơ bản -->
      <li nz-submenu nzTitle="{{'thong_so_co_ban' | translate}}" [(nzOpen)]="openMap.menu3"
        (nzOpenChange)="openHandler('menu3')">
        <!-- chữ nền -->
        <ng-container>
          <div class="config-text" style="width: 100%">
            <mat-form-field style="width: 100%">
              <mat-label>{{'chu_nen' | translate}}</mat-label>
              <textarea matInput
                [ngModel]="staticdata['input_text_placeholder_' + functionService.selectedLanguageCode] | vhLanguage : 'input_text_placeholder' : objectChoosing.component"
                (ngModelChange)="staticdata['input_text_placeholder_' + functionService.selectedLanguageCode] = $event"
                (blur)="updateContent()">
                </textarea>
            </mat-form-field>
          </div>
        </ng-container>

        <!-- màu chữ nền -->
        <div class="color-pick">
          <span class="title w-50">{{'mau_chu_nen' | translate}}</span>
          <input class="input-color w-50" type="button" [cpOKButton]="true"
            [(colorPicker)]="class['note-bill__boundary-placeholder']['color']"
            [style.background]="class['note-bill__boundary-placeholder']['color']" (colorPickerClose)="updateObject()"
            [cpWidth]="'230px'" />
        </div>
        <!-- cấu hình text -->
        <div class="config-font-size mt-2">
          <div class="field-row-font" style="width: 65%">
            <mat-form-field title="Font" style="width: 100%">
              <mat-label> {{'kieu_chu' | translate}}
              </mat-label>
              <mat-select [(ngModel)]="
                      class['note-bill__boundary']['font-family']
                    " (ngModelChange)="updateClass()" [(value)]="class['note-bill__boundary']['font-family']">
                <mat-option *ngFor="let font of fonts" [value]="font.value">{{
                  font.name
                  }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="field-row-size" style="width: 35%">
            <mat-form-field title="Size" style="width: 100%">
              <mat-label> {{'kich_thuoc' | translate}}</mat-label>
              <input matInput type="number" [ngModel]="
                      class['note-bill__boundary']['font-size'] | vhnumber
                    " (ngModelChange)="
                      class['note-bill__boundary']['font-size'] =
                        $event + 'px'
                    " />
            </mat-form-field>
          </div>
        </div>
        <div class="config-font">
          <p class="title-font" style="margin-bottom: 10px;"> {{'dinh_dang' | translate}}</p>
          <div class="field-row">
            <button class="font-text-btn font-text-btn-bold" title="Bold" nz-button [nzType]="
                    class['note-bill__boundary']['font-weight'] == 'bold'
                      ? 'primary'
                      : 'default'
                  " (click)="
                    class['note-bill__boundary']['font-weight'] =
                      class['note-bill__boundary']['font-weight'] == 'bold'
                        ? '500'
                        : 'bold';
                    updateClass()
                  ">
              <span style="font-weight: 600">B</span>
            </button>
            <button class="font-text-btn font-text-btn-italic" title="Italic" nz-button [nzType]="
                    class['note-bill__boundary']['font-style'] == 'italic'
                      ? 'primary'
                      : 'default'
                  " (click)="
                    class['note-bill__boundary']['font-style'] =
                      class['note-bill__boundary']['font-style'] == 'normal'
                        ? 'italic'
                        : 'normal';
                    updateClass()
                  ">
              <i nz-icon nzType="italic" nzTheme="outline" style="font-size: 14px"></i>
            </button>
            <button class="font-text-btn font-text-btn-underline" title="Underline" nz-button [nzType]="
                    class['note-bill__boundary']['text-decoration'] ==
                    'underline'
                      ? 'primary'
                      : 'default'
                  " (click)="
                    class['note-bill__boundary']['text-decoration'] =
                      class['note-bill__boundary']['text-decoration'] ==
                      'none'
                        ? 'underline'
                        : 'none';
                    updateClass()
                  ">
              <i nz-icon nzType="underline" nzTheme="outline" style="font-size: 14px"></i>
            </button>
            <button class="font-text-btn font-text-btn-line-through" title="Line-through" nz-button [nzType]="
                    class['note-bill__boundary']['text-decoration'] ==
                    'line-through'
                      ? 'primary'
                      : 'default'
                  " (click)="
                    class['note-bill__boundary']['text-decoration'] =
                      class['note-bill__boundary']['text-decoration'] ==
                      'none'
                        ? 'line-through'
                        : 'none';
                    updateClass()
                  ">
              <i nz-icon nzType="strikethrough" nzTheme="outline" style="font-size: 14px"></i>
            </button>
            <button class="font-text-btn font-text-btn-uppercase" title="Uppercase" nz-button [nzType]="
                    class['note-bill__boundary']['text-transform'] ==
                    'uppercase'
                      ? 'primary'
                      : 'default'
                  " (click)="
                    class['note-bill__boundary']['text-transform'] =
                      class['note-bill__boundary']['text-transform'] ==
                      'none'
                        ? 'uppercase'
                        : 'none';
                    updateClass()
                  ">
              <span>AB</span>
            </button>
            <div>
              <input id="color2" title="Color" type="button" [cpOKButton]="true"
                [(colorPicker)]="class['note-bill__boundary']['color']"
                [style.background]="class['note-bill__boundary']['color']" (colorPickerClose)="updateObject()"
                [cpWidth]="'230px'" [cpPositionRelativeToArrow]="true" />
            </div>
          </div>
        </div>
        <!-- màu nền -->
        <div class="color-pick">
          <span class="title w-50">{{'mau_nen' | translate}}</span>
          <input class="input-color w-50" type="button" [cpOKButton]="true"
            [(colorPicker)]="class['note-bill__boundary']['background-color']"
            [style.background]="class['note-bill__boundary']['background-color']" (colorPickerClose)="updateObject()"
            [cpWidth]="'230px'" />
        </div>
      </li>
      <!-- Khoảng đệm -->
      <li nz-submenu [nzTitle]="'khoang_dem' | translate" [(nzOpen)]="openMap.menu8" (nzOpenChange)="openHandler('menu8')">
        <div class="px-2">
          <app-padding-config
            [objectChoosing]="objectChoosing"
            [device]="device"
            [class]="class"
            [classPadding]="class['note-bill__boundary']"
            [paddingConfigs]="[
              { type: 'top' },
              { type: 'bottom' },
              { type: 'left' },
              { type: 'right' }
            ]">
          </app-padding-config>
        </div>
      </li>
      <!-- Cấu hình đổ bóng -->
      <li nz-submenu nzTitle="{{'do_bong' | translate}}" [(nzOpen)]="openMap.menu4"
        (nzOpenChange)="openHandler('menu4')">
        <app-shadow-config [device]="device" [config]="config" [class]="class"
          [shadowClass]="class['note-bill__boundary']" [shadowConfig]="config['box-shadow']"
          [objectChoosing]="objectChoosing">
        </app-shadow-config>
      </li>
      <!-- Cấu hình hình dạng viền -->
      <li nz-submenu nzTitle="{{'kieu_vien' | translate}}" [(nzOpen)]="openMap.menu2"
        (nzOpenChange)="openHandler('menu2')">
        <app-borders-config [device]="device" [class]="class" [borderClass]="class['note-bill__boundary']"
          [id_object]="objectChoosing._id" [elementChoosing]="objectChoosing">
        </app-borders-config>
        <!-- Nút mở rộng -->
        <div class="item-border my-3" style="float: right;">
          <p class="m-0 title-border my-2" (click)="openViewAll(styles_field[0])">{{'mo_rong' | translate}} &#8594;</p>
        </div>
      </li>

      <!-- Cấu hình xoay-->
      <li nz-submenu nzTitle="{{'cau_hinh_xoay' | translate}}" [(nzOpen)]="openMap.menu9"
        (nzOpenChange)="openHandler('menu9')">
        <app-rotate-config [classRotate]="class['note-bill']" [config]="config" [device]="device"
          [objectChoosing]="objectChoosing"></app-rotate-config>
      </li>
      <!-- Cấu hình hiệu ứng -->
      <li nz-submenu nzTitle="{{'hieu_ung' | translate}}" [(nzOpen)]="openMap.menu7"
        (nzOpenChange)="openHandler('menu7')">
        <app-choose-animations-config [elementChoosing]="objectChoosing" [id_object]="objectChoosing._id"
          [device]="device" [class]="class" [config]="config" [staticdata]="staticdata" [effectFileUsing]="'input'"
          [cursorClass]="class['note-bill']" [effect_hover]="effect_hover" [customize]="customize" [type]="'object'"
          (openAnimationDetail)="openAnimationDetail($event)">
        </app-choose-animations-config>
      </li>
    </ul>
  </ng-container>
  <div class="view-more" *ngIf="isViewAll">
    <div class="view_more-border" *ngIf="currentViewAll.index == 1">
      <app-borders-radius-config [device]="device" [class]="class" [borderRadiusClass]="class['note-bill__boundary']"
        [id_object]="objectChoosing._id" [elementChoosing]="objectChoosing">
      </app-borders-radius-config>
    </div>
    <div class="editor_effect-hover" *ngIf="currentViewAll.index == 3">
      <app-animations-config [type]="type" [elementChoosing]="objectChoosing" [device]="device"
        [staticdata]="staticdata" [id_object]="objectChoosing._id" [customize]="customize"></app-animations-config>
    </div>
  </div>
</div>